import type { LoginOptions, LoginResult } from '../../operations/login'
import { login } from '../../operations/login'
import { blankLine, sayError } from '../output'
import { waitForEnter } from '../prompts/confirm'
import { reportLogin } from '../reporter'

export interface LoginCommandOptions {
  server?: string
  /**
   * Show the authorization link and wait for Enter before opening a browser.
   *
   * Used when the login is a step inside another command: a browser window taking focus out of nowhere,
   * mid-deploy, is startling in a way that one typing `flowrunner login` is not.
   */
  confirmOpen?: boolean
}

/** The login as a step inside another command: narrated, but leaving the process alone. */
export function runLogin(options: LoginCommandOptions = {}): Promise<LoginResult> {
  const loginOptions: LoginOptions = {
    server : options.server,
    onEvent: reportLogin,
  }

  if (options.confirmOpen) {
    loginOptions.onBeforeOpen = () =>
      waitForEnter('  Press Enter to open it in your browser, or Ctrl+C to cancel. ')
  }

  return login(loginOptions)
}

export async function loginCommand(options: LoginCommandOptions): Promise<void> {
  try {
    await runLogin(options)
  } catch (error) {
    blankLine()
    sayError(`  Login failed: ${ (error as Error).message }`)
    process.exit(1)
  }

  // The command is done, and nothing else is waiting on this process.
  process.exit(0)
}
